import { render, staticRenderFns } from "./UserDataOther.vue?vue&type=template&id=b7e0d524"
import script from "./UserDataOther.vue?vue&type=script&lang=ts"
export * from "./UserDataOther.vue?vue&type=script&lang=ts"
import style0 from "./UserDataOther.vue?vue&type=style&index=0&id=b7e0d524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports